<template>
    <div class="page_content">
        <div class="page_detail">
            <Form ref="form_data" @handleSubmit="handleSubmit" :form_data="form_data"></Form>
        </div>
    </div>
</template>

<script>
    import Form from "@/components/Form";
    import { 
        getVisitConfigDetail,
        saveVisitTimeConfig,
		getTypeSelect
    } from "@/api/visitSet";

    export default {
        components: {
            Form
        },
        data() {
            return {
                query:'',
                ruleInfo:'',

                form_data: {
                    show_submit_btn: true,
                    show_close_btn: true,
                    close_reset_btn: true,
                    list: [
                        {
                            type: "text",
                            name: "name",
                            title: "规则名称",
                            placeholder: '请输入规则名称',
                            options: {}
                        },
						{
						    type: "select",
						    name: "type",
						    title: "拜访类型",
						    options: {},
						    list: [],
						},
                        {
                            type: "text",
                            name: "visit_times",
                            title: "拜访时间",
                            placeholder: '请输入拜访时间（为空则使用全局拜访时间）',
                            options: {}
                        },
                        {
                            type: "tree-select",
                            name: "department_ids",
                            title: "适用部门",
                            options: {},
                            treeData: [],
                            multiple: true
                        },
                        {
                            type: "tree-select",
                            name: "role_ids",
                            title: "适用岗位",
                            options: {},
                            treeData: [],
                            multiple: true
                        },
                        {
                            type: "tree-select",
                            name: "group_ids",
                            title: "客户分组",
                            options: {},
                            treeData: [],
                            multiple: true
                        },
                        {
                            type: "number",
                            name: "sort",
                            title: "排序号",
                            placeholder: '请输入排序号（排序值越大权重越高）',
                            options: {}
                        },
                    ]
                },
            }
        },
        async created() {
            this.query = this.$route.query

            this.$method.get_department().then(res => {
                this.form_data.list.forEach(item => {
                    if (item.name == "department_ids") {
                        item.treeData = [...res];
                    }
                });
            });
            this.$method.get_role_tree().then(res => {
                this.form_data.list.forEach(item => {
                    if (item.name == "role_ids") {
                        item.treeData = [...res];
                    }
                });
            });
            this.$method.get_group().then(res => {
                this.form_data.list.forEach(item => {
                    if (item.name == "group_ids") {
                        item.treeData = [...res];
                    }
                });
            });
			getTypeSelect().then(res=>{
				this.form_data.list.forEach(item => {
				    if (item.name == "type") {
				        item.list = res.data.list.map(it=>{
						return {
							key: it.value,
							value: it.label
						}
						});
				    }
				});
			})
            this.$nextTick(()=>{
                if(this.query.id){
                    this.getDetail()
                }
		    })
        },
        methods: {
            chhang_data(data,type){
                let temp_arr = []
                if (data) {
                    let temp_data = data.split(',')
                    temp_data.forEach(item => {
                        if(type==1){
                             temp_arr.push(item)
                        }else {
                             temp_arr.push(Number(item))
                        }
                    })
                }
                return temp_arr
            },
            getDetail(){
                getVisitConfigDetail({
                    data:{
                        id:this.query.id
                    }
                }).then(res=>{
                    this.form_data.list.forEach(item=>{
                        if(item.name=='name'){
                              item.options.initialValue= res.data.list.name
                        }
                        if(item.name=='sort'){
                              item.options.initialValue= res.data.list.sort
                        }
						if(item.name=='type'){
						      item.options.initialValue= res.data.list.type
						}
                        if(item.name=='visit_times'){
                              item.options.initialValue=  res.data.list.visit_times
                        }
                        if(item.name=='department_ids'){
                              item.options.initialValue= this.chhang_data(res.data.list.department_ids)
                        }
                        if(item.name=='role_ids'){
                              item.options.initialValue= this.chhang_data(res.data.list.role_ids)
                        }
                        if(item.name=='group_ids'){
                              item.options.initialValue=  this.chhang_data(res.data.list.group_ids)
                        }
                    })
                })
            },
            handleSubmit(data){
                saveVisitTimeConfig({
                    data:{
                        id:this.query.id ? this.query.id : undefined,
                        name:data.values.name,
                        sort:data.values.sort,
						type:data.values.type,
                        visit_times:data.values.visit_times,
                        department_ids:data.values.department_ids ? data.values.department_ids.join(',') : '',
                        role_ids:data.values.role_ids ? data.values.role_ids.join(',') : '',
                        group_ids:data.values.group_ids ? data.values.group_ids.join(',') : '',
                    }
                }).then(res=>{
                    this.$router.back()
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    
</style>